import React from "react";
import { notification } from "antd";
import { clearLogin } from "./lib/auth";

/**
 * Show a toast. Pass the axios error directly via `notifyError(error)`.
 * A 401 means the token expired: clear the session and go back to the login page.
 */
export const openNotification = (data) => {
	if (data.status === 401) {
		clearLogin();
		window.location.href = "/";
		return;
	}
	const errors = data.errors ? Object.values(data.errors).flat() : [];
	notification[data.type || "info"]({
		message: data.message,
		description: errors.length ? (
			<ul style={{ paddingLeft: 18, marginBottom: 0 }}>
				{errors.map((error, i) => (
					<li key={i}>{error}</li>
				))}
			</ul>
		) : (
			data.description || null
		),
	});
};

export const notifyError = (error, fallback = "Something went wrong") => {
	const response = error && error.response;
	openNotification({
		type: "error",
		message: (response && response.data && (response.data.message || response.data.error)) || fallback,
		errors: (response && response.data && response.data.errors) || null,
		status: response ? response.status : "error",
	});
};

export const notifySuccess = (message, description) =>
	openNotification({ type: "success", message, description });

/** Scenario (VR module) definitions shared by the add-contact and launch pages. */
export const SCENARIOS = [
	{
		key: "medical_admin",
		title: "Medical Administration",
		scheme: "lcds-medadmin",
		icon: require("./Assets/images/lcds_icons/LCDS_MedAdmin_Icon_256.png"),
	},
	{
		key: "sling_and_left",
		title: "Sling and Lift",
		scheme: "lcds-slinglift",
		icon: require("./Assets/images/lcds_icons/LCDS_Sling_Icon_256 copy.png"),
	},
	{
		key: "vehicle_check_driving",
		title: "Vehicle Check",
		scheme: "lcds-businspection",
		icon: require("./Assets/images/lcds_icons/LCDS_Inspection_Icon_256_copy_3.png"),
	},
	{
		key: "vehicle_driving",
		title: "Vehicle Driving",
		scheme: "lcds-busdriving",
		icon: require("./Assets/images/lcds_icons/LCDS_Driver_Icon_256 copy 2.png"),
	},
];

export const formatDate = (value) => {
	if (!value) return "-";
	const d = new Date(value);
	if (Number.isNaN(d.getTime())) return String(value);
	return d.toLocaleDateString("en-CA", { year: "numeric", month: "short", day: "numeric" });
};

export const formatDateTime = (value) => {
	if (!value) return "-";
	const d = new Date(value);
	if (Number.isNaN(d.getTime())) return String(value);
	return d.toLocaleString("en-CA", {
		year: "numeric",
		month: "short",
		day: "numeric",
		hour: "2-digit",
		minute: "2-digit",
	});
};
